import { AdminMemberReportHTML } from './AdminMemberReportHTML';

export default AdminMemberReportHTML;